import React, { Component, type SyntheticEvent } from 'react';
import { type DeviceTypeEnum } from '../../../types/DeviceType';
import { Label } from '../Elements';
import { Input } from '../Elements/Input';
import { type UserInfoFieldType } from '../types';
import s from './styles.scss';

export interface ITextFieldProps {
  required?: boolean;
  appearance: DeviceTypeEnum;
  dataHook?: string;
  isValid?: boolean;
  errorMessage?: string;
  placeholder?: string;
  name?: UserInfoFieldType;
  type?: string;
  label?: string;
  value?: string;
  validate?(value: string): boolean;
  onChange?(args: any): void;
  disabled?: boolean;
}

export class TextField extends Component<ITextFieldProps, any> {
  static defaultProps = {
    onChange: () => void 0,
    type: 'text',
  };

  handleChange = (e: SyntheticEvent<HTMLInputElement>): void => {
    const value = e.currentTarget.value;
    const { name, isValid } = this.props;
    this.props.onChange({ value, name, isValid: isValid !== false });
  };

  handleBlur = (e: SyntheticEvent<HTMLInputElement>): void => {
    const value = e.currentTarget.value;
    const name = this.props.name;
    const isValid = this.props.validate(value);
    this.props.onChange({ value, name, isValid });
  };

  isError = () => this.props.isValid === false;

  render() {
    const { required, appearance, value, name, label, placeholder, dataHook, errorMessage, disabled, type } =
      this.props;

    return (
      <div className={s.textFieldContainer}>
        <Label appearance={appearance} htmlFor={name} title={label} required={required} />
        <Input
          error={this.isError()}
          errorMessage={errorMessage}
          appearance={appearance}
          placeholder={placeholder}
          id={name}
          name={name}
          type={type || 'text'}
          required={required}
          data-hook={dataHook}
          value={value}
          disabled={disabled}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onKeyUp={this.handleChange}
          aria-invalid={this.isError()}
        />
      </div>
    );
  }
}
